module.exports = __webpack_public_path__ + "img/SGP-RVB-Noir-XL.578d8fe2.png";